const modalConstants = {
  MODAL_CREATE: "MODAL_CREATE",
  MODAL_SHOW: "MODAL_SHOW",
  MODAL_HIDE: "MODAL_HIDE",
  MODAL_TOOGLE: "MODAL_TOOGLE",
  MODAL_DESTROY: "MODAL_DESTROY",
}

export default modalConstants
